import * as React from "react";
import { UitkCardAlohaContentSection, UitkCardAlohaLink } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { CardTitle } from "components/flexComponents/Packages/components/CardTitle";
import { HotelRating } from "components/flexComponents/Packages/components/HotelRating";
import { AddressAndNeighborhood } from "components/flexComponents/Packages/components/AddressAndNeighborhood";
import PricesAndDate from "components/flexComponents/Packages/components/PricesAndDate";
import FlightInfo from "components/flexComponents/Packages/components/FlightInfo";
import DescriptionAndGuestReviewSectionWrapper from "components/flexComponents/Packages/components/DescriptionAndGuestReviewSectionWrapper";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { useLocalization } from "@shared-ui/localization-context";
import { PackageCardProps } from "components/flexComponents/Packages/typings";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";

export const DefaultCardContents = ({ packageItem, index, language, overImage, grid }: PackageCardProps) => {
  const { formatText } = useLocalization();
  const content = (
    <UitkCardAlohaContentSection padded={false}>
      <UitkCardAlohaContentSection>
        <UitkLayoutFlex justifyContent="space-between" className="truncate">
          <UitkLayoutFlexItem className="truncate">
            <div>
              <CardTitle cardTitle={packageItem.hotelName} />
              <HotelRating rating={packageItem.hotelStarRating} isText={false} />
              <AddressAndNeighborhood packageItem={packageItem} />
            </div>
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem>
            <div>
              <PricesAndDate
                packageItem={packageItem}
                renderSavingBadge={true}
                renderDates={true}
                overImage={overImage}
              />
            </div>
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
        <UitkLayoutFlex>
          <UitkLayoutFlexItem className="truncate">
            <div>
              <FlightInfo packageItem={packageItem} />
            </div>
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
      </UitkCardAlohaContentSection>
      <DescriptionAndGuestReviewSectionWrapper
        packageItem={packageItem}
        language={language}
        renderReviewRating={true}
      />
      <UitkCardAlohaLink>
        <TrackedLink
          className="uitk-card-link"
          rfrr={`card-${index}`}
          href={packageItem.shopUrl}
          aria-label={formatText("package.card.ariaLabel.fh")}
          moduleName="packages"
        />
      </UitkCardAlohaLink>
    </UitkCardAlohaContentSection>
  );
  if (grid) {
    return <UitkLayoutGridItem colSpan={2}>{content}</UitkLayoutGridItem>;
  }

  return content;
};
